/**
 * Example JavaScript singleton module
 */
window.addEventListener("load",function(){
  var expand = document.querySelectorAll('button[data-action="expand-nav"]');
  var close = document.querySelectorAll('button[data-action="close-nav"]');
  var nav = document.querySelectorAll('nav[data-function="slide-nav"]');
  expand[0].addEventListener("click",function(){
    //console.log('open');
    if (nav[0].className == "Slide-nav open") {
      nav[0].className = "Slide-nav";
    } else {
      nav[0].className = "Slide-nav open";
    }
  });

  close[0].addEventListener("click",function(){
    //console.log('close');
    nav[0].className = "Slide-nav";
  });

});

// var Example = (function($) {

//   function initExample() {
//     // do something
//   }

//   function init() {

//     // return early if no corresponding module present
//     if (!$('.Example').length) {
//       return;
//     }

//     initExample();

//   }

//   return {
//     init: init
//   };

// }(jQuery));

// jQuery(document).ready(Example.init);
